import { useEffect } from "react";
import { ILayout, useLayout } from "../../core";

const Footer = () => {
  const { config } = useLayout();
  useEffect(() => {
    updateDOM(config);
  }, [config]);
  return (
    <>
      <div className="d-flex gap-3 gap-md-3 gap-xl-10 flex-wrap justify-content-center align-items-center p-4">
        <ul className="d-flex gap-3 p-0 m-0">
          <li className="list-unstyled">
            <span className="text-gray-800 fw-semibold me-1">
              {new Date().getFullYear().toString()}&copy;
            </span>
          </li>
          <li className="list-unstyled">
            <a
              href="https://pense.co.uk/"
              target="_blank"
              rel="noreferrer"
              className="text-gray-800 text-hover-primary"
            >
              Pense
            </a>
          </li>
          <li className="list-unstyled">
            <a
              href="https://pense.co.uk/"
              target="_blank"
              rel="noreferrer"
              className="menu-link px-2"
            >
              About
            </a>
          </li>
        </ul>
        <div>
          <p className="text-center fs-8 fs-md-8 fs-lg-7 text-wrap m-0">
            Pense Ltd is authorised and regulated by the Financial Conduct
            Authority number 231629. Find us on the FCA Website{" "}
            <a
              style={{ color: "blue", textDecoration: "underline" }}
              href="https://register.fca.org.uk/s/firm?id=001b000000MfOTwAAN"
              target="_blank"
              rel="noreferrer"
            >
              view our FCA register entry
            </a>
          </p>
        </div>
      </div>
    </>
  );
};

const updateDOM = (config: ILayout) => {
  if (config.app?.footer?.fixed?.desktop) {
    document.body.classList.add("data-kt-app-footer-fixed", "true");
  }

  if (config.app?.footer?.fixed?.mobile) {
    document.body.classList.add("data-kt-app-footer-fixed-mobile", "true");
  }
};

export { Footer };
